(function () {
  function getDialogById(id) {
    if (!id) return null;
    return document.getElementById(id);
  }

  // Used for normal open (button click) — focuses first field.
  function openDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.showModal === "function") {
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute("open", "open");
      }
    } else {
      dialog.setAttribute("open", "open");
    }

    const firstInput = dialog.querySelector("input, textarea, select, button");
    if (firstInput) firstInput.focus();
  }

  // Used for success/error reopen — does NOT focus the first input (so scroll won't get overridden).
  function openDialogNoFocus(dialog) {
    if (!dialog) return;

    if (typeof dialog.showModal === "function") {
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute("open", "open");
      }
    } else {
      dialog.setAttribute("open", "open");
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === "function") {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
    }
  }

  function showToastNearTrigger(dialogId) {
    const trigger = document.querySelector(`[data-modal-open="${dialogId}"]`);
    if (!trigger) return;

    const message = trigger.getAttribute("data-toast-message") || "Sent";

    // Remove any existing toast next to this trigger
    const next = trigger.nextElementSibling;
    if (next && next.classList && next.classList.contains("catanachs-enquiry-toast")) {
      next.remove();
    }

    const toast = document.createElement("div");
    toast.className = "catanachs-enquiry-toast is-visible";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");

    toast.innerHTML = `
      <span class="catanachs-enquiry-toast__text"></span>
      <button type="button" class="catanachs-enquiry-toast__close" aria-label="Dismiss">×</button>
    `;

    toast.querySelector(".catanachs-enquiry-toast__text").textContent = message;

    toast.querySelector(".catanachs-enquiry-toast__close").addEventListener("click", () => {
      toast.remove();
    });

    trigger.insertAdjacentElement("afterend", toast);
  }



  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest && e.target.closest("[data-modal-open]");
    if (openBtn) {
      const id = openBtn.getAttribute("data-modal-open");
      const dialog = getDialogById(id);
      openDialog(dialog);
      return;
    }

    const closeBtn = e.target.closest && e.target.closest("[data-modal-close]");
    if (closeBtn) {
      const dialog = closeBtn.closest("dialog");
      closeDialog(dialog);
      return;
    }

    // Click backdrop to close
    const maybeDialog = e.target;
    if (maybeDialog && maybeDialog.tagName === "DIALOG") {
      const rect = maybeDialog.getBoundingClientRect();
      const clickedInDialog =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;

      if (!clickedInDialog) closeDialog(maybeDialog);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const openDialogEl = document.querySelector("dialog[open]");
    if (openDialogEl) closeDialog(openDialogEl);
  });

  document.addEventListener("DOMContentLoaded", function () {
    const dialogs = document.querySelectorAll("dialog.catanachs-enquiry__dialog");

    for (const d of dialogs) {
      const feedback = d.querySelector(".contact-form__success, .contact-form__error");
      if (!feedback) continue;

      if (!feedback.hasAttribute("tabindex")) feedback.setAttribute("tabindex", "-1");

      openDialogNoFocus(d);

      requestAnimationFrame(() => {
        feedback.scrollIntoView({ block: "center", inline: "nearest" });
        try {
          feedback.focus();
        } catch (e) {}
      });

      // Auto-close ONLY if it's a success message marked for autoclose
      const shouldAutoClose =
        feedback.classList.contains("contact-form__success") &&
        feedback.getAttribute("data-autoclose") === "true";

      if (shouldAutoClose) {
        window.setTimeout(() => {
          closeDialog(d);
          showToastNearTrigger(d.id);
        }, 3000);
      }


      break;
    }
  });

    // Show spinner overlay while the contact form is submitting
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (!form || !form.matches) return;

    // Only target Shopify contact forms
    if (!form.matches('form[action^="/contact"]')) return;

    const dialog = form.closest("dialog.catanachs-enquiry__dialog");
    if (!dialog) return;

    // Mark dialog busy (CSS will display overlay)
    dialog.classList.add("is-submitting");
    dialog.setAttribute("aria-busy", "true");

    // Disable submit button to prevent double submits
    const submitBtn =
      form.querySelector("[data-enquiry-submit]") ||
      form.querySelector('button[type="submit"], input[type="submit"]');

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute("aria-disabled", "true");
    }
  });

  // If the browser restores the page from back/forward cache, clear loading state
  window.addEventListener("pageshow", function () {
    document.querySelectorAll("dialog.catanachs-enquiry__dialog.is-submitting").forEach((d) => {
      d.classList.remove("is-submitting");
      d.removeAttribute("aria-busy");

      const btn = d.querySelector("[data-enquiry-submit]");
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
      }
    });
  });
})();
